module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A Nessie ProgressBar is a component that represents the progress when loading items / inspecting elements, it receives as a prop the percentage of the progress.</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;ProgressBar/&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/ProgressBar/README.md
// module id = 377
// module chunks = 0